import React from 'react';
import './AeroSwitch.css';

/**
 * AeroSwitch: the flat v3 switch used on every Aero settings page.
 *
 * Props:
 *   checked    bool, controlled value
 *   onChange   fn(nextChecked)
 *   disabled   bool
 *   label      optional text beside the track (also its accessible name)
 *   aria-label accessible name when there is no visible label
 */
export default function AeroSwitch({ checked, onChange, disabled = false, label, 'aria-label': ariaLabel }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label ? undefined : ariaLabel}
      className={`aero-sw${checked ? ' on' : ''}`}
      disabled={disabled}
      onClick={() => !disabled && onChange && onChange(!checked)}
    >
      <span className="aero-sw-track" aria-hidden="true" />
      {label && <span>{label}</span>}
    </button>
  );
}
